let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fKOLx")).then(() => parcelRequire('aUp3o'));